//routes.js

import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import AuthGuard from './auth/AuthGuard';
import { authRoles } from './auth/authRoles';
import Loadable from './components/Loadable';
import MatxLayout from './components/MatxLayout/MatxLayout';
import PatientAccounts from './views/Patient/detailsPage/PatientAccounts';
import materialRoutes from 'app/views/material-kit/MaterialRoutes';
import ProfilePage from './views/profile/ProfilePage';
import LandingScreen from './views/landing/LandingScreen';
import SpecialistsList from './views/Specialists/SpecialistsList';
import whatsApp from './views/whatsApp/WhatsApp';
import WhatsApp from './views/whatsApp/WhatsApp';
import Loading from './components/MatxLoading';

//Admin Page
const Admin1 = Loadable(lazy(() => import('app/views/Lists/AdminList')));

//Docotr Page
const Doctor = Loadable(lazy(() => import('app/views/Doctor/DoctorList')));

//Patient Page
const PatientList = Loadable(lazy(() => import('app/views/Patient/PatientList')));
const Patient = Loadable(lazy(() => import('app/views/Patient/detailsPage/Patient')));
const PatientHistory = Loadable(
  lazy(() => import('app/views/Patient/detailsPage/PatientFindings'))
);
const PatientInvestigation = Loadable(
  lazy(() => import('app/views/Patient/detailsPage/PatientInvestigation'))
);
const PatientTreatment = Loadable(
  lazy(() => import('app/views/Patient/detailsPage/PatientTreatment'))
);

const SpecialistPatient = Loadable(lazy(() => import('app/views/Specialists/SpecialistPatient')));
const SpecialistPatientView = Loadable(
  lazy(() => import('app/views/Specialists/SpecialistPatientView'))
);

const Accounts = Loadable(lazy(() => import('app/views/Calendar/FullViewer')));
const SpecialistAccount = Loadable(
  lazy(() => import('app/views/specialistAccount/SpecialistAccountView'))
);
const Services = Loadable(lazy(() => import('app/views/services/Services')));
const Medication = Loadable(lazy(() => import('app/views/Medication/Medication')));
// const whatsApp = Loadable(lazy(() => import('app/views/whatsApp/whatsApp')));
const PDF = Loadable(lazy(() => import('app/pdf/ReactPdf')));
const Invoice = Loadable(lazy(() => import('app/views/Patient/components/Invoice')));

// session pages
const NotFound = Loadable(lazy(() => import('app/views/sessions/NotFound')));
const JwtLogin = Loadable(lazy(() => import('app/views/sessions/JwtLogin')));
const ForgotPassword = Loadable(lazy(() => import('app/views/sessions/ForgotPassword')));
const PatientQR = Loadable(lazy(() => import('app/views/Patient/components/QRpatient')));
const ContactUS = Loadable(lazy(() => import('app/views/landing/ContactUs')));

// dashboard page
const Analytics = Loadable(lazy(() => import('app/views/dashboard/Analytics')));

const routes = [
  {
    element: (
      <AuthGuard>
        <MatxLayout />
      </AuthGuard>
    ),
    children: [
      // dashboard route
      {
        path: '/dashboard/default',
        element: <Analytics />,
        auth: authRoles.admin
      },

      //admin route
      {
        path: '/dashboard/admin',
        element: <Admin1 />,
        auth: authRoles.admin
      },
      {
        path: '/dashboard/doctor',
        element: <Analytics />,
        auth: authRoles.doctor
      },
      {
        path: '/dashboard/specialist',
        element: <Analytics />,
        auth: authRoles.specialist
      },
      //Doctor Routes
      {
        path: '/admin/doctors',
        element: <Doctor />,
        auth: authRoles.admin
      },
      {
        path: '/doctor/specialist',
        element: <SpecialistsList />,
        auth: authRoles.doctor
      },
      //Services Route
      {
        path: '/services',
        element: <Services />,
        auth: authRoles.doctor
      },
      //Specialist Route
      {
        path: '/specialistaccount',
        element: <SpecialistAccount />,
        auth: authRoles.doctor
      },
      //Medication Route
      {
        path: '/medication',
        element: <Medication />,
        auth: authRoles.doctor
      },
      {
        path: '/whatsapp',
        element: <WhatsApp />,
        auth: authRoles.doctor
      },
      {
        path: '/pdf',
        element: <PDF />,
        auth: authRoles.doctor
      },

      //Patient Route
      {
        path: '/patient',
        element: <PatientList />,
        auth: authRoles.doctor
      },
      {
        path: '/patient/details',
        element: <Patient />
      },
      {
        path: '/patient/findings',
        element: <PatientHistory />
      },
      {
        path: '/patient/investigation',
        element: <PatientInvestigation />
      },
      {
        path: '/patient/treatment',
        element: <PatientTreatment />
      },
      {
        path: '/patient/accounts',
        element: <PatientAccounts />
      },
      {
        path: '/accounts',
        element: <Accounts />
      },
      {
        path: '/invoice',
        element: <Invoice />
      },
      {
        path: '/specialist/patient',
        element: <SpecialistPatient />
      },
      {
        path: '/specialist/patient/view',
        element: <SpecialistPatientView />
      }
      // e-chart rooute
    ]
  },

  // session pages route
  { path: '/session/404', element: <NotFound /> },
  { path: '/session/signin', element: <JwtLogin /> },
  { path: '/session/forgot-password', element: <ForgotPassword /> },
  { path: '/user-profile', element: <ProfilePage /> },
  { path: '/patient_qr', element: <PatientQR /> },
  //Admin
  { path: '/dashboard/admin', element: <Admin1 /> },

  // { path: '/', element: <Navigate to="dashboard/default" /> },
  { path: '*', element: <NotFound /> },
  { path: '/contact-us', element: <ContactUS /> },
  { path: '/', element: <LandingScreen /> }
];

export default routes;
